<template>
  <div>
    <!-- MAIN WRAPPER (search, carousel, tabs sports, bigtable) -->
    <div v-show="!viewEvent">
      <!-- <Search class="mt-2 mx-2" v-if="$vuetify.breakpoint.smAndDown" /> -->

      <AlertActivateTwoStepsAuthentication
        v-if="$store.state.operators.multifactor == 1"
      />

      <Carousel />

      <MainEvents />

      <!-- ONLY ImpCom -->
      <template
        v-if="$domain() === 'imperialbetcom' && $vuetify.breakpoint.mobile"
      >
        <v-row no-gutters>
          <v-col cols="12" lg="6">
            <div class="mb-2 cursor-pointer" @click="goLiveCasino">
              <v-img
                width="100%"
                src="https://dozr8la71aog.cloudfront.net/domains/imperialbetcom/img/custom/cassino-ao-vivo.png"
                lazy-src="https://dozr8la71aog.cloudfront.net/domains/imperialbetcom/img/custom/cassino-ao-vivo.png"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
          </v-col>
          <v-col cols="6" lg="3">
            <div
              class="mb-2 mr-1 cursor-pointer"
              @click="
                $router.push(
                  $store.state.logged.status
                    ? {
                        name: 'casino-game',
                        params: {
                          gameID: '519',
                          isFreeGame: 'false',
                        },
                      }
                    : {
                        name: 'casino',
                        query: { gameSearch: 'blackjack' },
                        hash: '#scrollTop',
                      }
                )
              "
            >
              <v-img
                width="100%"
                src="https://dozr8la71aog.cloudfront.net/domains/imperialbetcom/img/custom/promo.png"
                lazy-src="https://dozr8la71aog.cloudfront.net/domains/imperialbetcom/img/custom/promo.png"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
          </v-col>
          <v-col cols="6" lg="3">
            <div
              class="mb-2 ml-1 cursor-pointer"
              @click="
                $router.push(
                  $store.state.logged.status
                    ? {
                        name: 'casino-game',
                        params: {
                          gameID: 'vs25bomb',
                          isFreeGame: 'false',
                        },
                      }
                    : {
                        name: 'casino',
                        query: { gameSearch: 'bomb' },
                        hash: '#scrollTop',
                      }
                )
              "
            >
              <v-img
                width="100%"
                src="https://dozr8la71aog.cloudfront.net/domains/imperialbetcom/img/custom/slots.png"
                lazy-src="https://dozr8la71aog.cloudfront.net/domains/imperialbetcom/img/custom/slots.png"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
          </v-col>
        </v-row>
      </template>
      <!-- / ONLY ImpCom -->

      <!-- ================ -->
      <!-- SPORTS NAV TAB'S -->
      <div
        style="overflow-x: auto; padding: 0 8px"
        :style="
          $vuetify.breakpoint.mobile
            ? 'border-radius: 0px;'
            : 'border-radius: 5px;'
        "
        class="d-flex colorBreadcrumbs mb-2 justify-space-between"
      >
        <template v-for="sport in sportsNavTabs">
          <div
            v-if="sport.id_sport != '100'"
            :key="sport.id_sport"
            class="
              pa-4
              text-center
              align-center
              d-flex
              flex-column
              cursor-pointer
              sportTab
            "
            :class="active_id_sport == sport.id_sport ? 'primary--text' : ''"
            @click="listTable(sport.id_sport)"
          >
            <template v-if="sport.icon_img">
              <div
                class="d-flex align-center justify-center mb-1"
                :class="active_id_sport == sport.id_sport ? 'primary' : ''"
                style="
                  border-radius: 30px;
                  background-color: rgba(0, 0, 0, 0.3);
                  width: 60px;
                  height: 60px;
                "
              >
                <img
                  style="border-radius:50%"
                  class="mb-0"
                  width="48px"
                  :src="sport.icon_img"
                />
              </div>
              <div
                class="white--text text-uppercase"
                style="font-size: 12px; white-space: nowrap"
              >
                {{ sport.name_sport }}
              </div>
            </template>
            <div v-else>
              <iconSport
                :idSport="sport.id_sport"
                :color="active_id_sport == sport.id_sport ? 'primary' : 'white'"
                :size="'28'"
                class="pb-1"
              />
              <div
                class="white--text"
                style="font-size: 14px; white-space: nowrap"
              >
                {{ sport.name_sport }}
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- / SPORTS NAV TAB'S -->
      <!-- ================== -->

      <!-- ========= -->
      <!-- BIG TABLE -->
      <div class="colorDominant pb-2" style="border-radius: 5px">
        <div class="colorTable" id="bigtable-print" style="position: relative">
          <div v-if="loading">
            <v-progress-linear
              absolute
              indeterminate
              color="primary"
            ></v-progress-linear>
          </div>

          <!-- ================ -->
          <!-- TABS DATAS -->

          <div class="d-flex justify-center">
            <v-tabs
              style="border-radius: 5px 5px 0 0"
              v-model="tab"
              show-arrows
              background-color="colorDominant colorTabs"
              class="d-print-none"
              :style="
                $isAgent() && !$vuetify.breakpoint.smAndDown
                  ? 'width: 75%;'
                  : ''
              "
            >
              <template v-for="day in days">
                <v-tab
                  :key="day"
                  @click="dayActive = day"
                  :disabled="tabDisabled"
                  class="white--text"
                >
                  {{ formatDateTabs(day) }}
                </v-tab>
              </template>
            </v-tabs>

            <div
              class="d-flex align-center"
              v-if="$isAgent() && !$vuetify.breakpoint.smAndDown"
            >
              <v-spacer />
              <v-btn text color="info" @click="$agentPrintBt()">
                Imprimir
                <v-icon class="ml-2">mdi-printer</v-icon>
              </v-btn>
            </div>
          </div>

          <!-- / TABS DATAS -->
          <!-- ================ -->

          <!-- ALERTA -->
          <v-alert
            class="mx-4 my-2"
            text
            dense
            :type="
              loadingTableMessage === this.$t('loading') ? 'info' : 'warning'
            "
            border="left"
            v-if="
              sports[active_id_sport] &&
                sports[active_id_sport].tables[dayActive].showingCategories
                  .length == 0
            "
          >
            {{ loadingTableMessage }}
            <!-- Cotações do Pré-ogo em manutenção. Em breve estaremos normalizando nosso
            serviço. -->
          </v-alert>

          <ToolbarTabMarkets
            v-if="
              sports[active_id_sport] &&
                sports[active_id_sport].tables[dayActive].showingCategories
                  .length > 0
            "
            :type="'bigTable'"
            :sportNameInBt="
              sports[active_id_sport] ? sports[active_id_sport].name : ''
            "
          />

          <!-- FOR CATEGORIES (PAÍSES) -->
          <div
            v-if="
              sports[active_id_sport] &&
                sports[active_id_sport].tables[dayActive].showingCategories
                  .length > 0
            "
          >
            <div
              v-for="(category, indexCategory) in sports[active_id_sport]
                .tables[dayActive].showingCategories"
              :key="`category-id-${category.id}-${indexCategory}`"
            >
              <!-- FOR TOURNAMENTS (TORNEIOS) -->
              <template
                v-for="(tournament, indexTournament) in category.tournaments"
              >
                <div
                  class="d-flex subtitle-2 justify-space-between overflow-hidden text-truncate"
                  :key="`tournament-id-${tournament.id}-${indexTournament}`"
                  style="background: rgba(0, 0, 0, 0.25)"
                >
                  <!-- Tournament ToolBar -->
                  <div
                    class="subtitle-2 text--secondary col-md-3 col-lg-4 d-flex align-center col-sm-6 overflow-hidden px-2"
                  >
                    <img
                      class="flag mr-2 ma-0"
                      width="24"
                      :src="
                        `https://dozr8la71aog.cloudfront.net/flags/1x1/${category.flag}.svg`
                      "
                      :alt="category.name"
                    />

                    <span class="text-truncate">
                      {{ category.name }} &nbsp;›&nbsp;
                      {{ tournament.name }}
                    </span>

                    <!-- big table fav -->
                    <!-- Adicionar aos Favoritos -->
                    <v-spacer v-if="$vuetify.breakpoint.xsOnly"></v-spacer>
                    <v-btn x-small icon style="margin-top: -2px" class="mx-1">
                      <v-icon
                        :color="setFav(tournament.id) ? 'yellow' : 'grey'"
                        @click="setStoreFavorite(category.id, tournament.id)"
                        size="18"
                      >
                        mdi-star
                      </v-icon>
                    </v-btn>
                    <CashoutIcon :show="tournament.encerrar_aposta == '1'" />
                  </div>

                  <!-- mercados desktop -->
                  <div
                    v-if="!$vuetify.breakpoint.xsOnly"
                    class="col-md-9 col-lg-8 pa-0 ma-0"
                    style="font-size: 11px"
                  >
                    <div class="row no-gutters">
                      <!--Mercados principais events table -->
                      <div
                        v-for="(market, index) in marketsIds"
                        :key="`${market.legends}-${index}`"
                        :class="[`col col-${12 / marketsIds.length}`]"
                      >
                        <div class="row no-gutters flex-nowrap justify-center">
                          <template v-for="(legend, index) in market.legends">
                            <div
                              :key="`legend-${index}`"
                              class="
                          px-1
                          transparent
                          d-flex
                          justify-center
                          align-center
                        "
                              :style="{
                                'min-width': $vuetify.breakpoint.xsOnly
                                  ? '50px'
                                  : '56px',
                                'min-height': $vuetify.breakpoint.xsOnly
                                  ? '50px'
                                  : '50px',
                                margin: $vuetify.breakpoint.xsOnly
                                  ? '0 0 0 4px !important'
                                  : '0 4px 0 4px !important',
                              }"
                            >
                              {{ legend }}
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- mobile date and markets labels bar -->
                <div
                  v-if="$vuetify.breakpoint.xsOnly"
                  class="d-flex subtitle-2 justify-space-between overflow-hidden text-truncate"
                  :key="`events-id-${tournament.id}-${indexTournament}`"
                  style="border-top: 1px solid rgba(0, 0, 0, 0.5); background: rgba(0, 0, 0, 0.15)"
                >
                  <!-- Tournament ToolBar -->
                  <div
                    class="subtitle-1 text--secondary d-flex align-center col-sm-6 overflow-hidden px-2"
                  >
                    <span class="text-truncate pl-1">
                      {{ formatDateTabs(days[tab]) }}
                    </span>
                  </div>

                  <div
                    class="col-md-9 col-lg-8 pa-0 ma-0"
                    style="font-size: 11px"
                  >
                    <div class="row no-gutters">
                      <!--Mercados principais events table -->
                      <div
                        v-for="(market, index) in marketsIds"
                        :key="`${market.legends}-${index}`"
                        :class="[`col col-${12 / marketsIds.length}`]"
                      >
                        <div class="row no-gutters flex-nowrap justify-center">
                          <template v-for="(legend, index) in market.legends">
                            <div
                              :key="`legend-${index}`"
                              class="
                                    px-1
                                    transparent
                                    d-flex
                                    justify-center
                                    align-center
                                  "
                              style="
                                    min-width: 50px;
                                    min-height: 50px;
                                    margin: 0 0 0 4px !important
                                  "
                            >
                              {{ legend }}
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- FOR EVENTS (EVENTOS) -->
                <template v-for="event in tournament.events">
                  <!-- ROW EVENT -->

                  <div
                    style="border-top: 1px solid rgba(0, 0, 0, 0.5)"
                    class="container pl-3 py-5"
                    :key="`event-id-${event.id}`"
                    v-show="event.odds.some((odd) => odd.show == true)"
                  >
                    <div class="layout row no-wrap">
                      <!-- DESCRIPTION COL: 50% -->
                      <div
                        class="flex xs6 md4 cursor-pointer d-flex align-center"
                        @click="
                          routerPush(
                            category.id,
                            tournament.id,
                            event.id,
                            category.name,
                            tournament.name,
                            event.description,
                            category.flag
                          )
                        "
                      >
                        <div class="pl-2">
                          <!-- Times -->
                          <div
                            :style="{
                              width: `${styles.descriptionWidth}px`,
                            }"
                          >
                            <div class="d-flex align-center">
                              <TeamLogo
                                :id_sport="active_id_sport"
                                :id_team="event.id_team_1"
                                :type_size="'small_logo'"
                                :size="'16px'"
                                class="mr-1"
                              />
                              <div class="text-truncate nameComp subtitle-2">
                                {{ event.description.split(" X ")[0] }}
                              </div>
                            </div>
                            <div class="d-flex align-center">
                              <TeamLogo
                                :id_sport="active_id_sport"
                                :id_team="event.id_team_2"
                                :type_size="'small_logo'"
                                :size="'16px'"
                                class="mr-1"
                              />
                              <div class="text-truncate nameComp subtitle-2">
                                {{ event.description.split(" X ")[1] }}
                              </div>
                            </div>
                          </div>

                          <!-- Data - Horário - isLive -->
                          <div class="caption text--secondary">
                            <span v-if="!$vuetify.breakpoint.xsOnly">
                              {{ event.scheduled | formatDate }}
                            </span>
                            <span class="ml-1">{{
                              event.scheduled | formatHour
                            }}</span>
                            <span
                              v-if="event.liveodds > 0"
                              class="
                                mr-1
                                my-1
                                px-2
                                v-chip v-chip--no-color v-chip--outlined
                                theme--dark
                                v-size--x-small
                              "
                              ><span class="v-chip__content">live</span></span
                            >
                            <span class="primary--text ml-1">+odds</span>
                            <!-- {{
                            event.count_odds
                              | formatPlus($vuetify.breakpoint.smAndDown)
                          }} -->
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-md-9 col-lg-7 d-flex align-center text-center col-sm-6 col col-md-8 col-lg-8"
                      >
                        <div class="row no-gutters justify-end">
                          <div
                            v-for="(market, i) in marketsIds"
                            :key="`${market.name_market}-${i}`"
                            :class="[`col col-${12 / marketsIds.length}`]"
                          >
                            <div
                              v-if="
                                market.id_market == 1 &&
                                  event.odds.filter(
                                    (odd) =>
                                      odd.id_market == '1' &&
                                      odd.super_odds == '1' &&
                                      odd.active == '1'
                                  ).length > 0
                              "
                              style="position: relative;"
                              :style="
                                $vuetify.breakpoint.md
                                  ? 'left: 3%'
                                  : $vuetify.breakpoint.xs
                                  ? 'right: 20%'
                                  : ''
                              "
                            >
                              <div class="mx-auto" style="position: absolute;">
                                <ArrowVertical />
                              </div>
                            </div>
                            <div
                              class="row no-gutters flex-nowrap justify-center"
                            >
                              <template v-for="o in event.odds">
                                <ListOdds
                                  :key="o.id_odd"
                                  v-if="market.id_market === o.id_market"
                                  :event="event"
                                  :odd="o"
                                  :minOdd="$store.state.operators.odd_min"
                                  :live="false"
                                />
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="
          sports[active_id_sport] &&
            sports[active_id_sport].tables[dayActive].categories.length > 0
        "
        class="d-flex align-center justify-center pt-6"
      >
        <v-btn
          color="primary"
          outlined
          @click="loadMore"
          small
          :loading="loadingMore"
          class="px-8"
        >
          {{ $t("loadMore") }}
        </v-btn>
      </div>
      <!-- / BIG TABLE -->
      <!-- ================ -->
    </div>
    <!-- / MAIN WRAPPER (search, carousel, tabs sports, bigtable) -->

    <!-- VIEW EVENT CHILDREN -->
    <div v-show="viewEvent">
      <v-toolbar dense class="colorDominant my-1">
        <div class="d-flex justify-space-between flex-grow-1">
          <v-btn icon @click="$router.go(-1)">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <BottomSheetEvents v-if="viewEvent" />
          <GridOrlistOdds />
        </div>
      </v-toolbar>
      <router-view></router-view>
    </div>
    <!-- / VIEW EVENT CHILDREN -->

    <!-- /// OLD CODE - EVENT DIALOG - DESCONTINUADO -->
    <!-- ============ -->
    <!-- EVENT DIALOG -->
    <!-- <v-dialog
      scrollable
      color="colorDominant"
      v-model="dialogEvent"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      width="600"
      persistent
      :retain-focus="false"
    >
      <router-view></router-view>
    </v-dialog> -->
    <!--  /EVENT DIALOG -->
    <!-- ============== -->
  </div>
</template>
<style scoped>
.sportTab:hover {
  background: rgba(255, 255, 255, 0.1);
}
</style>
<script>
import AlertActivateTwoStepsAuthentication from "@/components/alert-activate-two-steps-authentication/AlertActivateTwoStepsAuthentication.vue";
import iconSport from "@/components/icon-sport";
import Carousel from "@/views/home/events/components/carousel";
// import Search from "@/components/search/search";
import BottomSheetEvents from "@/components/bottom-sheet-events/bottom-sheet-events.vue";
import storeFavorite from "@/util/storeFavorite";
import CashoutIcon from "@/components/table/table-components/CashoutIcon.vue";
import GridOrlistOdds from "@/components/breadcrumbs/gridOrlistOdds.vue";
import TeamLogo from "@/components/team-logo/";
import axios from "axios";
import localApi from "@/util/localApi.js";
import MainEvents from "@/components/main-events";
import ToolbarTabMarkets from "@/views/home/events/components/toolbar-markets";
import ListOdds from "@/components/table/table-components/list-odds";
import ArrowVertical from "@/assets/ArrowVertical";

export default {
  name: "big-table",
  components: {
    AlertActivateTwoStepsAuthentication,
    iconSport,
    Carousel,
    // Search,
    BottomSheetEvents,
    CashoutIcon,
    GridOrlistOdds,
    TeamLogo,
    MainEvents,
    ToolbarTabMarkets,
    ListOdds,
    ArrowVertical,
  },
  data: () => ({
    active_id_sport: 6046,
    sports: {},
    categories: [],
    tab: 0,
    tabDisabled: false,
    days: [],
    dayActive: "",
    styles: {
      oddWidth: "",
      descriptionWidth: "",
    },
    loading: false,
    goBack: false,
    toggle_exclusive: 0,
    _tabChangeTimeoutId: 0,
    motiveDialog: false,
    sportsNavTabs: [],
    loadingMore: false,
  }),
  async mounted() {
    // Debug Console
    //
    // STYLES Obj:
    //
    if (this.$vuetify.breakpoint.xsOnly) {
      var device_width = window.screen.width; // 370px
      // Calculo da largura da Odd;
      this.styles.oddWidth = device_width / 2 / 3 - 10;
      // Calculo da largura do time;
      this.styles.descriptionWidth = device_width / 2 - 40;
    } else {
      this.styles.oddWidth = 56;
    }
    //
    // SETUP
    //
    // Create Array Table Days
    // Create Object Sports Personalizado
    // !!! IMPORTANTE !!!
    await this.handleTableDays();
    await this.handleSportsObj();

    // Aplicando Icones para os Esportes nas Tabs
    // como Imagens do Operador
    this.sportsNavTabs = await this.$handlerIconsImgSports(
      this.sportsByInfoTable,
      "large"
    );

    // Protecao da Rota Big Table
    const { sport, live } = this.$route.query;
    if (sport && live && !this.$isAgent()) {
      this.$router.replace({ path: "/bt" });
    }
    if (localStorage.getItem("p4fmotive") == "insufficient_balance") {
      this.$store.commit("setMotiveDialog", true);
      localStorage.removeItem("p4fmotive");
    }
  },
  computed: {
    marketsIds() {
      return this.$store.getters.getIdMarkets(
        this.active_id_sport,
        this.$vuetify.breakpoint.name,
        false,
        "bigTable"
      );
    },
    // Retrieve Favorite Tournaments
    getFavoritesList() {
      return this.$store.state.favoriteTournaments;
    },
    // Retrieve Sports by InfoTable;
    sportsByInfoTable() {
      return this.$store.getters.getSports;
    },
    // Retrieve Coupons
    coupons: function() {
      return this.$store.state.coupons;
    },
    // Table Days
    tableDays() {
      return this.$store.state.operators.table_days;
    },
    // dialogEvent
    dialogEvent() {
      return this.$store.state.dialogEvent;
    },
    // viewEvent
    viewEvent() {
      return this.$route.params.event ? true : false;
    },
    // loading() {
    //   return this.$t("loading");
    // },
  },
  watch: {
    // Consulta por seleção do DIA;
    dayActive() {
      this.tabDisabled = true;
      this.listTable(this.active_id_sport, false);
    },
    dialogEvent(val) {
      if (!this.goBack) {
        !val && this.$router.go(-1);
      } else {
        this.goBack = false;
      }
    },
    $route(val) {
      // LÓGICA PARA TRATAR O GO BACK DO NAVEGADOR.
      if (val.name === "bigTable") {
        this.goBack = true;
        this.$store.commit("setDialogEvent", false);
      }
    },
  },
  methods: {
    loadMore() {
      this.loadingMore = true;

      setTimeout(() => {
        this.sports[this.active_id_sport].tables[
          this.dayActive
        ].showingCategories.push(
          ...this.sports[this.active_id_sport].tables[
            this.dayActive
          ].categories.splice(0, 5)
        );

        this.loadingMore = false;
      }, 50);
    },
    // =========================== //
    // Create Array Days Table
    // =========================== //
    handleTableDays() {
      var numberDays = Number(this.tableDays); // Table Days
      this.days = []; // array
      // Util para incr. ou decrementar horas
      Date.prototype.addHours = function(value) {
        this.setHours(this.getHours() + value);
      };
      // Push Today "HOJE" in array;
      var today = new Date();
      today.addHours(Number(this.$gmtShort()));
      today = new Date(today).toISOString().slice(0, -14);
      this.days.push(today);
      // Push table days in array;
      for (var i = 1; i < numberDays; i++) {
        // Incrementa
        var newDate = new Date().toDateString();
        var date = new Date(newDate);
        var day = date.setDate(date.getDate() + i);

        // Formata
        var formatDay = new Date(
          new Date(day).setHours(Number(this.$gmtShort()), 0, 0)
        )
          .toISOString()
          .slice(0, -14);
        // Push in array
        this.days.push(formatDay);
      }
    },
    handleSportsObj() {
      // Construindo o this.Sports
      this.sportsByInfoTable.forEach((sport) => {
        let sportObj = new Object();
        let dayObj = new Object();
        this.days.forEach((day) => {
          dayObj[day] = {
            // usamos esse arr para redefinir os jogos cacheados
            originalCategories: [],
            // vamos remover os jogos desse array a medida que carregamos mais
            categories: [],
            // jogos que estão sendo exibidos
            showingCategories: [],
            expired: null,
          };
          sportObj[sport.id_sport] = {
            name: sport.name_sport,
            tables: dayObj,
          };
          Object.assign(this.sports, sportObj);
        });
      });
      // AQUI É ONDE OCORRE O PRIMEIRO CONSUMO DA TABELA
      // ATRAVÉS DO WATCH
      // Set Day Today and Get list Table;
      this.dayActive = this.days[0];
      // console.log(this.sports);
    },
    // Verifica se o tempo da expiração da tabela
    // terminou, se sim, ele deve consultar a tabela novamente
    // se não, ele puxa a consulta salva;
    isExpired() {
      // Verifica se o Horário da Tabela Espixou
      var dateExpired = this.sports[this.active_id_sport].tables[this.dayActive]
        .expired;
      if (dateExpired != null) {
        var nowDate = new Date();
        if (nowDate < dateExpired) {
          this.sports[this.active_id_sport].tables[
            this.dayActive
          ].categories = [
            ...this.sports[this.active_id_sport].tables[this.dayActive]
              .originalCategories,
          ];

          this.sports[this.active_id_sport].tables[
            this.dayActive
          ].showingCategories = [
            ...this.sports[this.active_id_sport].tables[
              this.dayActive
            ].categories.splice(0, 5),
          ];

          this.tabDisabled = false;
          return false;
        } else {
          return true;
        }
      } else {
        // Cria a data de Expiração
        // Pega a hora atual e incrementa 10 minutos;
        var minutesToAdd = 5;
        var currentDate = new Date();
        var futureDate = new Date(currentDate.getTime() + minutesToAdd * 60000);
        // Armazena o Dia ativo com sua respectiva tempo de expiração

        this.sports[this.active_id_sport].tables[
          this.dayActive
        ].expired = futureDate;
        return true;
      }
    },
    // =========================== //
    // LIST BIG TABLE:
    // =========================== //
    async listTable(id_sport, refreshBalance = true) {
      // clearTimeout(this._tabChangeTimeoutId);

      if (refreshBalance) {
        this.refreshBalance();
      }

      // Active Style Item Ui
      this.active_id_sport = id_sport;
      // Lógica de Expiração da Consulta da Tabela;
      if (!this.isExpired()) return;
      // Consumo
      const body = {
        id_esporte: id_sport,
        domain: this.$domain(),
        date: this.dayActive,
      };
      this.loading = true;
      this.loadingTableMessage = this.$t("loading");

      const headers = {
        "Content-Type": "multipart/form-data",
        "x-api-key": "02ff96c8f50ce6a488812146d448a04b2e2358dd45d0dbb59824",
        language: localStorage.getItem("language") || "pt",
      };

      let endpoint =
        this.$domain() == "sysbet"
          ? "https://apidev.sga.bet/player/table/outerDay"
          : "https://v2.envrelease.com/player/table/outerDay";

      if (this.$domain() == "homolog") {
        endpoint = "https://apiv2dev.sga.bet/player/table/outerDay";
      }

      if (localApi()) {
        endpoint = localApi() + "/player/table/outerDay";
      }

      axios
        .post(endpoint, this.$formdata(body), { headers })
        .then((response) => {
          const categories = this.applyMarginOdds(response.data.categories);
          this.sports[id_sport].tables[this.dayActive].originalCategories = [
            ...categories,
          ];
          this.sports[id_sport].tables[this.dayActive].categories = [
            ...categories,
          ];
          this.sports[id_sport].tables[this.dayActive].showingCategories = [
            ...this.sports[id_sport].tables[this.dayActive].categories.splice(
              0,
              8
            ),
          ];
        })
        .then(() => {
          // Register Event select_content Analytics
          var sport_name = this.$store.getters.getNameSportById(`${id_sport}`);
          this.$gtag.select_content(sport_name, id_sport);
          // Quando o dia de Hoje não ter mais jogos,
          // enviar para o dia de amanhã;
          // if (this.dayActive == this.days[1]) {
          //   this.tab = 1;
          // }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.loadingTableMessage = error.response.data.messages.error;

            // if (this.days.length > this.days.indexOf(this.dayActive) + 1) {
            //   this._tabChangeTimeoutId = setTimeout(() => {
            //     this.$nextTick(() => {
            //       this.dayActive =
            //         this.days[this.days.indexOf(this.dayActive) + 1];
            //       this.tab++;
            //     });
            //   }, 700);
            // } else {
            //   clearTimeout(this._tabChangeTimeoutId);
            // }
          }
        })
        .finally(
          () => (
            (this.loading = false),
            (this.tabDisabled = false),
            (this.loadingTableMessage = this.$t("noEventsFound"))
          )
        );
    },
    applyMarginOdds(categories) {
      for (const categorie of categories) {
        for (const tournament of categorie.tournaments) {
          for (const event of tournament.events) {
            for (let odd of event.odds) {
              odd = this.$treatOdd(odd);
            }
          }
        }
      }
      return categories;
    },

    // =========================== //
    // PUSH ROUTE EVENT
    // =========================== //
    routerPush: function(
      categoryId,
      tournamentId,
      eventId,
      categoryName,
      tournamentName,
      eventDescription,
      categoryFlag
    ) {
      // this.$store.commit("setDialogEvent", true);
      this.$router.push({
        name: "btEvent",
        params: {
          sport: this.active_id_sport,
          category: categoryId,
          tournament: tournamentId,
          event: eventId,
        },
        query: {
          sport: this.sports[this.active_id_sport].name,
          category: categoryName,
          tournament: tournamentName,
          event: eventDescription,
          mobile: this.$vuetify.breakpoint.smAndDown,
          liveEvent: false,
          flag: categoryFlag,
        },
        hash: "#scrollTop",
      });
    },
    // FORMAT DATE TABS UI
    formatDateTabs(date) {
      Date.prototype.addHours = function(value) {
        this.setHours(this.getHours() + value);
      };
      // Push Today "HOJE" in array;
      var today = new Date();
      today.addHours(Number(this.$gmtShort()));
      today = new Date(today).toISOString().slice(0, -14);
      // if HOJE
      var dateTab = new Date(date).toISOString().slice(0, -14);
      if (dateTab === today) {
        return this.$t("today");
      }
      // if AMANHÃ
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      if (date === tomorrow.toISOString().slice(0, -14)) {
        return this.$t("tomorrow");
      }
      // FORMAT DATE FOR UI
      var formatDate = new Date(`${date}T00:00:00`)
        .toLocaleDateString()
        .slice(0, -5);
      return formatDate;
    },

    // Favorites
    setFav(id_tournament) {
      return this.getFavoritesList.some(
        (item) => item.id_tournament == Number(id_tournament)
      );
    },
    setStoreFavorite(id_category, id_tournament) {
      storeFavorite(this.active_id_sport, id_category, id_tournament);
    },
    refreshBalance() {
      if (
        !this.$isAgent() &&
        this.$isCreditOnline() &&
        this.$store.state.logged.status
      ) {
        this.$axios.get("/player/online/bank/balanceOnline").then((resp) => {
          this.$store.commit("setCash", resp.data.dados.balance);
          this.$store.commit("setBonus", {
            value: resp.data.dados.balance_bonus,
            status: resp.data.dados.balance_bonus_status,
          });
          this.$store.commit("setAvailableBalance", resp.data.dados.available_balance);
          this.$store.commit("setRestrictedBalance", resp.data.dados.restricted_balance);
        });
      }
    },
    goLiveCasino() {
      this.$router.push({
        path: `/casino/listGamesCategories/${this.$t("liveCasino")}`,
        hash: "#scrollTop",
      });
    },
  },
  filters: {
    formatPlus: (val, mobile) => {
      if (val != undefined && mobile) return `+${val} odds`;
      if (val != undefined) return `+${val}`;
      return "+";
    },
    formatDate: (val) => {
      var lang = document.documentElement.lang;
      if (lang == "pt-br") {
        return new Date(val.replace(" ", "T"))
          .toLocaleDateString()
          .slice(0, -5);
      } else {
        return new Date(val.replace(" ", "T")).toLocaleDateString();
      }
    },
    formatHour: (val) => {
      // Tratamento do Horário quando retornado do websocket ("2020-08-05T19:00:00.000Z")
      // retirar o "Z" do final.
      if (val.lastIndexOf("Z") != -1) {
        return new Date(`${val.slice(0, -5)}-03:00`)
          .toLocaleTimeString()
          .slice(0, -3);
      }
      return new Date(val.replace(" ", "T")).toLocaleTimeString().slice(0, -3);
    },
  },
};
</script>
